import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useLocRegionState = (region) => useQuery({ queryKey: ['regions', region], queryFn: async () => {
    const callback = await API.get(`/common/loc/states/${region}`)
    return callback?.data
}})

export default useLocRegionState;